import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DataEntryStore, DataEntryState } from './data-entry.store';

@Injectable()
export class DataEntryQuery extends QueryEntity<DataEntryState> {
    constructor(protected store: DataEntryStore) {
        super(store);
    }

    selectFormState(path) {
        return this.selectEntity(path, 'state');
    }
}
